import React, {useState, useEffect} from 'react';
import {useHistory } from 'react-router-dom';
import Avatar from '@material-ui/core/Avatar';
import useWindowDimensions from './hooks/useWindowDimensions';

//import { FacebookShareButton, LinkedinShareButton, TwitterShareButton, ViberShareButton, WhatsappShareButton} from "react-share";
import * as reactShare from "react-share";


const ShareBox = ({ newsId } ) => {

    const { height, width } = useWindowDimensions();

    const history = useHistory();
    const pathname = history?.location?.pathname;

    const shareUrl = `https://nuins.io/news-details/${newsId}`

    const shareMedia = ['Facebook', 'Linkedin', 'Twitter', 'Viber', 'Whatsapp'];


    const getSize = (size) => {
      if(width > 1024) return size;
      if(width > 640) {
        return (size / 10.24)*(0.01*width);
      }
      return (size /8.5)*(0.01*width); ;
    }
  
    return (
        <div className='share-box'>
          {shareMedia.map((media, i) => {
            const buttonName = `${media}ShareButton`;
            const iconName = `${media}Icon`;
            const ShareButton = reactShare[buttonName];
            const ShareIcon = reactShare[iconName];
            
            const getChildren = () => {
              return <Avatar className="avatar-size" >
                        <ShareIcon size={getSize(32)} round={true} />
                    </Avatar >
            }

            return <ShareButton  url={shareUrl} children={getChildren()} />
      
          })}
  
        </div>
    );
  }
  export default ShareBox;